export default "//file.bilionpass.com/japandx-portal/0.1.22/static/img/path.b8130a4f-661c51.png";